import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CSEService } from '../../services/cse.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import {
    EIASeries,
    FuelRate
} from '../../models/models';

@Component({
    selector: 'fuel-rate-form',
    templateUrl: './fuel-rate-form.component.html',
    standalone: false
})
export class FuelRateForm implements OnChanges {
    @Input() tableID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public tableItem: FuelRate = {} as FuelRate;
    public eiaSeriesList: EIASeries[] = [];

    constructor(private cseService: CSEService, private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnChanges() {
        this.getTableItem();
        //console.log("ngOnChanges", this.tableID, this.carrierID);
        this.cseService.getEIASeries().subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.eiaSeriesList = result.resultCollection;
            }
        });
    }

    private getTableItem() {
        if (this.tableID > 0) {
            this.cseService.getFuelRateByID(this.tableID).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    this.tableItem = result.resultCollection[0];
                }
            });
        }
        else {
            //var employeeID = parseInt(localStorage.getItem('EmployeeId')!);
            this.tableItem = {
                fuelRateID: 0,
                fuelRateDescription: "",
                eiaSeriesID: 0
            };
        }
    }

    public save() {
        this.utilService.isLoading = true;
        console.log("save", this.tableItem);
        this.cseService.saveFuelRate(this.tableItem).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.onRefresh.emit();
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                this.onRefresh.emit();
            }
        });

        this.tableItem = {} as FuelRate;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}